// extracted by mini-css-extract-plugin
export default {"home_image":"HomeImage_home_image__9WZZ8","image":"HomeImage_image__RzC3r"};